import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { GeofencingConfigService } from "../geofencing.config";
import { ALLOWED_ARGENTINIAN_LOCATION_IDS } from "../geofencing.const";

import { CurrentLocationModel } from "./current-location.model";

@Injectable({ providedIn: "root" })
export class CurrentLocationService {
	constructor(
		private config: GeofencingConfigService,
		private httpClient: CoreHttpClient
	) {}

	/**
	 * Returns id of provincia if the location is in Argentina. Otherwise returns null
	 * or undefined.
	 */
	getLocationId(lat: number, lon: number): Observable<string | undefined | null> {
		return this.httpClient
			.get<CurrentLocationModel>({
				url: this.config.getCurrentLocationEndpoint(),
				searchParams: { c: `${lat},${lon}` },
				withCredentials: false,
			})
			.pipe(
				map((response) => {
					const locationId = response?.gpsLocation?.AdministrativeArea;
					return ALLOWED_ARGENTINIAN_LOCATION_IDS.includes(locationId) ? locationId : null;
				})
			);
	}
}
